import { render, staticRenderFns } from "./AsociarEtiquetasIndividual.vue?vue&type=template&id=2166331d&"
import script from "./AsociarEtiquetasIndividual.vue?vue&type=script&lang=ts&"
export * from "./AsociarEtiquetasIndividual.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports